import { gql } from '@apollo/client';

export const GET_VENDOR_NOTIFICATIONS = gql`
  query GetVendorNotifications($notificationType: String) {
    vendorNotifications(notificationType: $notificationType) {
      id
      notificationId
      title
      body
      notificationType
      priority
      isRead
      readAt
      createdAt
      updatedAt
      sentVia
      userId
      userType
      vendorId
      orderId
      deliveryId
      deliveryStatus
      productId
      productCount
      productImageUrl
      productName
      suggestedPrice
    }
  }
`;

export const VENDOR_NOTIFICATION_RESPONSE = gql`
  mutation VendorNotificationResponse(
    $notificationId: String!
    $vendorPrice: Float!
    $vendorCatalogId: String!
    $quantity: Float!
    $productId: String!
  ) {
    vendorNotificationResponse(
      notificationId: $notificationId
      vendorPrice: $vendorPrice
      vendorCatalogId: $vendorCatalogId
      quantity: $quantity
      productId: $productId
    ) {
      success
      message
    }
  }
`;

export const VENDOR_SWIPE_LEFT = gql`
  mutation VendorSwipeLeft($productId: String!, $rejectionReason: String!, $notificationId: String!) {
    vendorSwipeLeft(
      productId: $productId
      rejectionReason: $rejectionReason
      notificationId: $notificationId
    ) {
      success
      message
    }
  }
`;

export const IGNORE_NOTIFICATION = gql`
  mutation IgnoreNotification($notificationId: String!) {
    ignoreNotification(notificationId: $notificationId) {
      success
      message
    }
  }
`;
